import React from "react"

import PropTypes from "prop-types"

import {isKeyboardClickEvent} from "../../utils/accessibilityUtil"
import {getDataTestId} from "../../utils/stringUtil"
import ButtonTertiaryIcon from "./buttonTertiaryIcon"

import "./buttonTertiary.scss"

export const BUTTON_TERTIARY_VARIANTS = {DEFAULT: "default", RED: "red"}

const ButtonTertiary = ({
    actionType,
    children,
    className,
    dataTestId,
    disabled = false,
    icon = null,
    iconPosition = "left",
    loading = false,
    onClick,
    variant = BUTTON_TERTIARY_VARIANTS.DEFAULT,
    withoutPadding = false,
    ...props
}) => {
    const handleKeyDown = event => {
        if (isKeyboardClickEvent(event) && !disabled && !loading && onClick) {
            event.preventDefault()
            onClick(event)
        }
    }

    return (
        <button
            aria-busy={loading}
            className={`button-tertiary${className ? " " + className : ""}${
                withoutPadding ? " no-padding" : ""
            } variant-${variant}`}
            data-testid={dataTestId || getDataTestId(children, "bouton")}
            disabled={disabled || loading}
            onClick={!disabled && !loading ? onClick : undefined}
            onKeyDown={handleKeyDown}
            type={actionType || "button"}
            {...props}
        >
            {iconPosition === "left" && <ButtonTertiaryIcon disabled={disabled} icon={icon} loading={loading} />}
            <span className="button-text">{children}</span>
            {iconPosition === "right" && <ButtonTertiaryIcon disabled={disabled} icon={icon} loading={loading} />}
        </button>
    )
}

ButtonTertiary.propTypes = {
    actionType: PropTypes.oneOf(["button", "reset", "submit"]),
    children: PropTypes.string.isRequired,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(Object.values(BUTTON_TERTIARY_VARIANTS)),
    withoutPadding: PropTypes.bool,
}

export default ButtonTertiary
